
import React, { Fragment } from 'react';
import { ButtonGroup } from 'react-bootstrap';
import { ArcaField } from '../../../code/ArcaField';
import { ArcaPageFieldState } from '../../../code/ArcaPageFieldState';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';
import { InputFieldArray } from '../Fields/InputFieldArray';

export class InvoiceEntryEditPanel extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            formState: this.buildFields(this.props.invoiceEntry),
            isVisible: this.props.isVisible,
        };
    }

    onUpdate(value, isValid, fieldName) {

        let { formState } = this.state
        let { invoiceEntry } = this.props

        var field = formState.GetField(fieldName);

        field.Value = value
        field.IsValid = isValid
        invoiceEntry[fieldName] = parseFloat(value)
        invoiceEntry.Changed = true;

        this.setState({
            invoiceEntry,
        });
    }

    onCancel() {
        let { formState } = this.state
        let { invoiceEntry } = this.props

        invoiceEntry.Description = formState.Fields[0].InitialValue
        invoiceEntry.Reason = formState.Fields[1].InitialValue
        invoiceEntry.Value = formState.Fields[2].InitialValue
        invoiceEntry.Changed = false
        
        this.props.onCancel()
    }

    render() {
        let { formState } = this.state
        let { invoiceEntry } = this.props

        return (
            <Fragment>
                {ArcaSecurity.IsAdmin
                    ? <span width='100%'><InputFieldArray
                        formState={formState}
                        onUpdate={this.onUpdate.bind(this)} /></span>
                    : 'Admin feature - not availible'}
                <div className='centerText'>
                    <ButtonGroup className='buttonGroup'>
                        {invoiceEntry.Changed
                            ? <ArcaLink text='Save' width='50%' onClick={() => this.props.onSave()} />
                            : null}
                        <ArcaLink text='Cancel' width='50%' onClick={() => this.onCancel()} />
                    </ButtonGroup>
                </div>
            </Fragment>
        );
    }

    buildFields(invoiceEntry) {
        let formState = new ArcaPageFieldState(invoiceEntry)

        formState.AddField(new ArcaField("Description", "Description", invoiceEntry.Description, true, true, 'text', 'freeform'));
        formState.AddField(new ArcaField("Reason", "Reason", invoiceEntry.Reason, true, true, 'text', 'freeform'));
        formState.AddField(new ArcaField("Amount", "Value", invoiceEntry.Value, true, true, 'currency', 'currency'));

        return formState
    }

}